import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy-dark py-8 px-6 text-center border-t border-white/5" data-id="element-46">
        <div className="max-w-6xl mx-auto space-y-4" data-id="element-47">
          <div className="flex items-center justify-center gap-4 text-sm font-body" data-id="element-48">
            <button onClick={() => setShowPrivacy(true)} className="text-white/50 hover:text-orange transition-colors underline underline-offset-2" data-id="element-49">
              Política de Privacidade
            </button>
            <span className="text-white/20" data-id="element-50">|</span>
            <button onClick={() => setShowTerms(true)} className="text-white/50 hover:text-orange transition-colors underline underline-offset-2" data-id="element-51">
              Termos de Uso
            </button>
          </div>
          <p className="font-body text-white/60 text-sm" data-id="element-52">
            © 2025 George Capital Coaching. Todos os direitos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidade" data-id="element-53">
        <p className="text-xs text-navy/50" data-id="element-54">
          Última atualização: Janeiro de 2025
        </p>

        <h3 className="font-heading font-bold text-navy text-base mt-2" data-id="element-55">
          1. Introdução
        </h3>
        <p data-id="element-56">
          A George Capital Coaching ("nós", "nosso") está comprometida em
          proteger a privacidade dos visitantes e clientes do nosso site. Esta
          Política de Privacidade descreve como coletamos, usamos e protegemos
          suas informações pessoais.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-57">
          2. Informações Coletadas
        </h3>
        <p data-id="element-58">
          Podemos coletar as seguintes informações quando você utiliza nosso
          site ou adquire nossos produtos:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-59">
          <li data-id="element-60">Nome completo</li>
          <li data-id="element-61">Endereço de e-mail</li>
          <li data-id="element-62">
            Dados de pagamento (processados por plataformas de pagamento
            terceirizadas e seguras)
          </li>
          <li data-id="element-63">
            Dados de navegação, como endereço IP, tipo de navegador e páginas
            visitadas
          </li>
        </ul>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-64">
          3. Uso das Informações
        </h3>
        <p data-id="element-65">As informações coletadas são utilizadas para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-66">
          <li data-id="element-67">Processar e entregar os produtos digitais adquiridos</li>
          <li data-id="element-68">Enviar comunicações relacionadas à sua compra</li>
          <li data-id="element-69">Melhorar a experiência do usuário em nosso site</li>
          <li data-id="element-70">Cumprir obrigações legais aplicáveis</li>
        </ul>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-71">
          4. Compartilhamento de Dados
        </h3>
        <p data-id="element-72">
          Não vendemos, alugamos ou compartilhamos suas informações pessoais com
          terceiros para fins de marketing. Seus dados podem ser compartilhados
          apenas com prestadores de serviço essenciais para a operação do
          negócio (como processadores de pagamento), sempre sob rigorosos
          padrões de segurança.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-73">
          5. Cookies
        </h3>
        <p data-id="element-74">
          Nosso site pode utilizar cookies e tecnologias semelhantes para
          melhorar a experiência de navegação, analisar o tráfego do site e
          personalizar conteúdo. Você pode configurar seu navegador para recusar
          cookies, embora isso possa afetar algumas funcionalidades do site.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-75">
          6. Segurança dos Dados
        </h3>
        <p data-id="element-76">
          Adotamos medidas técnicas e organizacionais adequadas para proteger
          suas informações pessoais contra acesso não autorizado, perda,
          alteração ou destruição. No entanto, nenhum método de transmissão pela
          internet é 100% seguro.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-77">
          7. Seus Direitos
        </h3>
        <p data-id="element-78">
          Em conformidade com a Lei Geral de Proteção de Dados (LGPD), você tem
          o direito de acessar, corrigir, excluir ou solicitar a portabilidade
          dos seus dados pessoais a qualquer momento.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-79">
          8. Alterações nesta Política
        </h3>
        <p data-id="element-80">
          Reservamo-nos o direito de atualizar esta Política de Privacidade a
          qualquer momento. As alterações serão publicadas nesta página com a
          data de atualização revisada.
        </p>
      </LegalModal>

      {/* Terms of Use Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Termos de Uso" data-id="element-81">
        <p className="text-xs text-navy/50" data-id="element-82">
          Última atualização: Janeiro de 2025
        </p>

        <h3 className="font-heading font-bold text-navy text-base mt-2" data-id="element-83">
          1. Aceitação dos Termos
        </h3>
        <p data-id="element-84">
          Ao acessar e utilizar este site e adquirir qualquer produto digital
          oferecido pela George Capital Coaching, você concorda integralmente
          com estes Termos de Uso. Caso não concorde com algum dos termos aqui
          descritos, solicitamos que não utilize nossos serviços.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-85">
          2. Descrição do Produto
        </h3>
        <p data-id="element-86">
          Os produtos oferecidos são materiais digitais de caráter educacional e
          informativo sobre finanças pessoais. O conteúdo não constitui
          aconselhamento financeiro profissional, consultoria de investimentos
          ou recomendação personalizada. As informações são de natureza geral e
          educativa.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-87">
          3. Entrega do Produto
        </h3>
        <p data-id="element-88">
          Após a confirmação do pagamento, o acesso ao produto digital será
          enviado automaticamente para o endereço de e-mail informado no momento
          da compra. É responsabilidade do comprador fornecer um endereço de
          e-mail válido e verificar sua caixa de entrada, incluindo a pasta de
          spam.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-89">
          4. Propriedade Intelectual
        </h3>
        <p data-id="element-90">
          Todo o conteúdo disponibilizado, incluindo textos, gráficos, imagens,
          layouts e materiais digitais, é de propriedade exclusiva da George
          Capital Coaching e está protegido pelas leis de direitos autorais. É
          estritamente proibido:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-91">
          <li data-id="element-92">
            Reproduzir, copiar ou distribuir o conteúdo sem autorização prévia
            por escrito
          </li>
          <li data-id="element-93">Compartilhar o material adquirido com terceiros</li>
          <li data-id="element-94">
            Utilizar o conteúdo para fins comerciais sem permissão expressa
          </li>
          <li data-id="element-95">Modificar ou criar obras derivadas a partir do material</li>
        </ul>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-96">
          5. Limitação de Responsabilidade
        </h3>
        <p data-id="element-97">
          A George Capital Coaching não garante resultados financeiros
          específicos. Os resultados podem variar de acordo com a situação
          individual de cada pessoa, seu comprometimento e a aplicação prática
          do conteúdo. Não nos responsabilizamos por decisões financeiras
          tomadas com base no material adquirido.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-98">
          6. Uso Adequado
        </h3>
        <p data-id="element-99">
          O usuário compromete-se a utilizar o site e os produtos adquiridos de
          forma ética e legal, não utilizando o conteúdo para qualquer
          finalidade ilícita ou que viole direitos de terceiros.
        </p>

        <h3 className="font-heading font-bold text-navy text-base" data-id="element-100">
          7. Modificações dos Termos
        </h3>
        <p data-id="element-101">
          A George Capital Coaching reserva-se o direito de modificar estes
          Termos de Uso a qualquer momento, sem aviso prévio. As alterações
          entram em vigor imediatamente após sua publicação nesta página.
        </p>
      </LegalModal>
    </>;
}